export default {
  namespaced: true,
  actions: {
    create({ commit }, studyRight) {
      return Vue.$http.post('candidate/study_rights', { studyRight })
    },
    destroy({ commit }, id) {
      return Vue.$http.delete(`candidate/study_rights/${id}`)
    }
  }
}
